import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { MatDialog, MatDialogRef, MatDialogConfig,MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MapSubjectComponent } from '../map-subject/map-subject.component';
import { log } from 'console';
@Component({
  selector: 'app-subject-mapping',
  templateUrl: './subject-mapping.component.html',
  styleUrls: ['./subject-mapping.component.scss']
})
export class SubjectMappingComponent implements OnInit {
  subject;
  subjectMappingForm: FormGroup;
  courseList: any;
  courseFilterList: any;
  examList: any;
  examFilterList: any;
  examCourseList: any;
  examCourseFilterList: any;
  isShownExamDiv = false;
  exStreamList: any;
  examStreamFilterList: any;
  examstreamList: any;
  examrelatedStreamFilterList: any;
  coCode:any;
  istableShow= false;
  mapSubjectList: any;
  x = sessionStorage.getItem('EsMapType');
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder,private httpClient: HttpClient,   public router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,) { }
    isDivShow=false;
  ngOnInit(): void {
    this.x = sessionStorage.getItem('EsMapType');
    this.isShownExamDiv = false;
    this.subjectMappingForm = this.fb.group({
      course: new FormControl (''),
      exam: new FormControl (''),
      stream: new FormControl (''),
      subject:new FormControl(''),
      optionlCompalsary:new FormControl(this.x),
      mapto:new FormControl(''),
    });
    let id=''
    this.fetchCourse();
    // this.fetchMapsub(id);
   
  //  this.fetchExam1();
    
  }


  fetchCourse() {
    const payload = {};
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {    
        this.courseList = res.data;
        this.courseFilterList= this.courseList.slice();
      }
    })
  }

  fetchExam() {
    const payload = {};
    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {    
        this.examList = res.data;
        this.examFilterList= this.examList.slice();
      }
    })

  }

  fetchExamRelatedCourse(id) {
    this.isShownExamDiv = true;
    const payload = {};
    payload['EmCoCode'] = id;
    payload['EmId'] = 0;
    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {    
        this.examCourseList = res.data;
        this.examCourseFilterList= this.examCourseList.slice();
        sessionStorage.setItem('EmCoCode',id);
      }
    })
  }

  fetchStream() {
    let x =sessionStorage.getItem('EmCoCode')
    const payload = {};
    payload['CoCode'] = x;
    payload['EmId'] = 0;
      this.umsService.getExamStream(payload).subscribe(res => {
      if (res.status) {   
        this.exStreamList = res.data;
        this.examStreamFilterList= this.exStreamList.slice();
             if(res.data.length != 0){
          this.isDivShow=true;
         }
         else{
          this.isDivShow=false;
         }
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    })
    
  }

  selectOption(){
   this.istableShow=true;
    this.fetchStream()
  }
  
  back(){
    this.subjectMappingForm.reset();
    this.ngOnInit();
    window.location.reload();
  }


  openBranchPopUp(e) {
    
    const dialogRef3 = this.dialog.open(MapSubjectComponent, 
      {
        data: e,
        width: "1000px",
        height: "270px",
        disableClose: true});

        dialogRef3.afterClosed().subscribe((submit) => {
          // let f=''
          // this.fetchMapsubForGrid(f);
        })
  }


fetchMapsubForGrid(id){
  this.istableShow=true;
  const payload = {};
payload['EsEmId'] =id;
payload['EsStrId'] = 0
sessionStorage.setItem('EsEmId',id);
  this.umsService.getDataForGridSubject(payload).subscribe(res => {
    this.mapSubjectList = res.data;
    })
}
}

